module.exports = __webpack_public_path__ + "img/whatsapp.5bb7394f.svg";